export default __webpack_public_path__ + "static/media/mr.cd28693c.jpg";